import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { SITE_URL, alternatesFor } from '../lib/routes'

// Centralized hreflang manager. Renders reciprocal tr/en/de + x-default
// <link rel="alternate"> tags for the current route, so every localized page
// set advertises its language equivalents to search engines. Mounted once in
// Router (like AnalyticsTracker); purely additive — it does not touch the
// per-page <title> or meta tags, and the canonical is CanonicalManager's.
// Route equivalence groups live in src/lib/routes.js (shared with the navbar).

export default function HreflangManager() {
    const { pathname } = useLocation()
    const alternates = alternatesFor(pathname)

    if (!alternates) return null

    return (
        <Helmet>
            <link rel="alternate" hrefLang="tr" href={`${SITE_URL}${alternates.tr}`} />
            <link rel="alternate" hrefLang="en" href={`${SITE_URL}${alternates.en}`} />
            <link rel="alternate" hrefLang="de" href={`${SITE_URL}${alternates.de}`} />
            <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${alternates.tr}`} />
        </Helmet>
    )
}
